import fetchAPI from "../../../common/fetchAPI";
import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { ProjectTypeStateClass } from "./interfaces/ProjectTypeStateClass";
import { RootState } from "../../../app/store";
import { sortData } from "../../../common/timeLiveFunction";
const initialState : ProjectTypeStateClass = {
    isLoading: false,
    ProjectTypeList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'ProjectType',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi{
    state:{
        projectType:ProjectTypeStateClass
    }
}

export const getAccountProjectTypeAsync = createAsyncThunk
<any,void,IThunkApi>
(
    "Api/getAccountProjectType",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/ProjectTypes","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        return json;
    }
)

export const getAccountProjectTypeByProjectTypeIdAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "ProjectType/getAccountProjectTypeByProjectTypeId",
    async (arg,thunkApi) =>{
        const response = await fetchAPI("api/ProjectTypes/" + arg ,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        return json;
    }
)

export const addAccountProjectTypeAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "ProjectType/addAccountProjectType",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/ProjectTypes/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        return json;
    }
)

export const updateAccountProjectTypeAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "ProjectType/updateAccountProjectType",
    async (arg,thunkApi)=>{
        const {AccountProjectTypeId,...argWithoutId} = arg;
        const response = await fetchAPI("api/v2/ProjectTypes/" + AccountProjectTypeId,"POST",argWithoutId,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const deleteAccountProjectTypeAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "ProjectType/deleteAccountProjectType",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/v2/ProjectTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        return json;
    }
)

export const DeleteSelectedAccountProjectTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ProjectType/DeleteSelectedAccountProjectType",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ProjectTypes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const projectTypeSlice= createSlice({
    name:"projectType",
    initialState,
    reducers:{
        resetSelectedRecordObjectInState:(state)=>{
            state.selectedRecord={}
        },
        checkedState: (state, action) => {
            const currentindex = state.ProjectTypeList.findIndex((item) => item.AccountProjectTypeId == action.payload);
            const newArray = [...state.ProjectTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.ProjectTypeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.ProjectTypeList.findIndex((item) => item.AccountProjectTypeId == action.payload);
            const newArray = [...state.ProjectTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.ProjectTypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.ProjectTypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.ProjectTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.ProjectTypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.ProjectTypeList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.ProjectTypeList;
            state.ProjectTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers(builder){
        builder
        .addCase(getAccountProjectTypeAsync.pending,(state)=>{
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(getAccountProjectTypeAsync.fulfilled,(state,{payload})=>{
            state.status = "idle";
            state.ProjectTypeList = payload;
            state.ProjectTypeList.map((item: any) => {
                item.isSelected = 0
            });
            state.isReload = false;
            state.isLoading = false;
            state.selectedRecord={};
        })
        .addCase(getAccountProjectTypeAsync.rejected,(state)=>{
            state.status = "failed";
        })

       
    .addCase(getAccountProjectTypeByProjectTypeIdAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
    })
    .addCase(getAccountProjectTypeByProjectTypeIdAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.selectedRecord = payload[0];
        state.isLoading = false;
    })
    .addCase(getAccountProjectTypeByProjectTypeIdAsync.rejected, (state) => {
        state.status = 'failed';
    })

    .addCase(addAccountProjectTypeAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
    })
    .addCase(addAccountProjectTypeAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = true;
        state.isLoading = false;
    })
    .addCase(addAccountProjectTypeAsync.rejected, (state) => {
        state.status = 'failed';
    })

    .addCase(updateAccountProjectTypeAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
    })
    .addCase(updateAccountProjectTypeAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = true;
        state.isLoading = false;
    })
    .addCase(updateAccountProjectTypeAsync.rejected, (state) => {
        state.status = 'failed';
    })

    .addCase(deleteAccountProjectTypeAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
    })
    .addCase(deleteAccountProjectTypeAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = true;
        state.isLoading = false;
    })
    .addCase(deleteAccountProjectTypeAsync.rejected, (state) => {
        state.status = 'failed';
    })

    .addCase(DeleteSelectedAccountProjectTypeAsync.pending, (state) => {
        state.status = 'loading';
        state.isLoading = true;
    })
    .addCase(DeleteSelectedAccountProjectTypeAsync.fulfilled, (state, { payload }) => {
        state.status = 'idle';
        state.isReload = true;
        state.isLoading = false;
    })
    .addCase(DeleteSelectedAccountProjectTypeAsync.rejected, (state) => {
        state.status = 'failed';
    })


    }
})

export const {resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting} = projectTypeSlice.actions
export const projectTypeState = (state: RootState) => state.projectType
export default projectTypeSlice.reducer